import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Download } from 'lucide-react';
import { Button } from '@mellify/ui';
import { buildRoute } from '../../routes/routeConfig';

export interface ReportsPageActionsProps {
  onCreateReport?: () => void;
  onExport?: () => void;
}

export const ReportsPageActions: React.FC<ReportsPageActionsProps> = ({
  onCreateReport,
  onExport,
}) => {
  const navigate = useNavigate();

  const handleCreate = () => {
    if (onCreateReport) {
      onCreateReport();
    } else {
      navigate(buildRoute.reportNew());
    }
  };

  return (
    <div className="flex items-center gap-2">
      {onExport && (
        <Button variant="outline" size="sm" onClick={onExport}>
          <Download className="w-4 h-4 mr-1.5" />
          Export
        </Button>
      )}
      <Button variant="primary" size="sm" onClick={handleCreate}>
        <Plus className="w-4 h-4 mr-1.5" />
        New Report
      </Button>
    </div>
  );
};

ReportsPageActions.displayName = 'ReportsPageActions';

export default ReportsPageActions;